import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import Item from '../../components/itens/item'


function ServicosScreen() {
    return (
        <Fragment>
            <Head titulo="Serviços Online da Prefeitura Municipal de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1} lg={3}>
                    <Col>
                        <Item
                            titulo={"NFS-E"}
                            descricao={"Nota Fiscal Eletrônica"}
                            awesome={"faFileInvoice"}
                            link={"https://macuco.govbr.cloud/NFSE.PORTAL/"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"DEISS"}
                            descricao={"Declaração Eletrônica de ISS"}
                            awesome={"faFileInvoiceDollar"}
                            link={"https://macuco.govbr.cloud:8443/deiss/servlet/br.com.cetil.ar.gips.hprincipal?XHYvHvw0LR7ksvk2RI32+A=="}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"IPTU"}
                            descricao={"Emissão do IPTU e 2ª via do IPTU online."}
                            awesome={"faHouse"}
                            link={"https://macuco.govbr.cloud:8443/cidadao/servlet/br.com.cetil.ar.jvlle.hatendimento"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"E-SIC"}
                            descricao={"Sistema Eletrônico de Serviço de Informação ao Cidadão"}
                            awesome={"faBullhorn"}
                            link={"https://prefeituramacuco.rj.gov.br/esic"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Ouvidoria"}
                            descricao={"Ouvidoria online, deixe sua dúvida, crítica ou sugestão à Prefeitura."}
                            awesome={"faEarListen"}
                            link={"https://sistema.ouvidorias.gov.br/publico/rj/macuco/Manifestacao/RegistrarManifestacao"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Administra Cidadão"}
                            descricao={"Indique problemas e melhorias na cidade enviando foto, localização e descrevendo sua solicitação."}
                            awesome={"faBuildingColumns"}
                            link={"https://prefeituramacuco.rj.gov.br/transparencia/ouvidoria"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Pesquisa de Satisfação"}
                            descricao={"Avalie as secretarias e serviços públicos municipais."}
                            awesome={"faPenToSquare"}
                            link={"https://prefeituramacuco.rj.gov.br/transparencia/ouvidoria"}
                            key={1}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ServicosScreen;